import * as Yup from "yup";
import { consultationType } from "../types/consultation";
import dayjs, { Dayjs } from "dayjs";

export const consultationInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  type:"",
  preferredDate: null as Dayjs | null,
  message: "",
  agreed: false,
};

export const consultationSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  type: Yup.string()
    .oneOf(Object.values(consultationType), "Select a valid type")
    .required("Consultation type is required"),
  preferredDate: Yup.mixed()
    .required("Preferred date is required")
    .test(
      "is-valid-date",
      "Preferred date is invalid",
      (value) => dayjs.isDayjs(value) && (value as Dayjs).isValid()
    ),
  message: Yup.string(),
  agreed: Yup.boolean().oneOf([true], "You must agree with the privacy policy"),
});
